/**
 * 预览弹框组件
 * @author tanglinxia
 * @since 21/09/08
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Logger from '@fe/logger';

import Dialog from 'components/dialog';
import PreviewSize from './preview-size';
import { gotoPosterEditor } from 'utils/common';
import { getPosterSizeList } from 'api/poster';

import './poster-setting-dialog.less';

const logger = Logger.get('store:poster-setting-dialog');

const SIZE_MAP = [
  { index: 0, name: '手机海报', width: 640, height: 1008 },
  { index: 1, name: '长图海报', width: 800, height: 2000 },
  { index: 2, name: '横版海报', width: 900, height: 500 },
  { index: 3, name: '方形海报', width: 600, height: 600 },
  { index: 4, name: '手机壁纸', width: 1080, height: 1920 },
];

const DEFINE_SIZE_INDEX = 5;
const MIN_SIZE = 40;
const MAX_SIZE = 3000;

class PosterSettingDialog extends Component {
  static propTypes = {
    hide: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      activeSize: SIZE_MAP[0],
      showWarning: false,
      customSizes: [],
    };
    this.inputWidthRef = React.createRef();
    this.inputHeightRef = React.createRef();
  }

  componentDidMount() {
    this.getPosterCustomSizeList();
  }

  // 选择海报尺寸
  selectSize(item) {
    const { showWarning } = this.state;
    this.setState({ activeSize: item });
    this.inputWidthRef.current.value &&
      (this.inputWidthRef.current.value = null);
    this.inputHeightRef.current.value &&
      (this.inputHeightRef.current.value = null);
    showWarning &&
      this.setState({
        showWarning: false,
      });
  }

  isIllegalInput(value) {
    const reg = /^[1-9]\d*$/;
    return (
      (!reg.test(value) || +value > MAX_SIZE || +value < MIN_SIZE) && !!value
    );
  }

  handleInputChange(e, type) {
    const currentValue = e.target.value;
    const otherValue = this.getInputRef(type === 'width' ? 'height' : 'width')
      .current.value;
    const { showWarning } = this.state;
    const result =
      this.isIllegalInput(currentValue) || this.isIllegalInput(otherValue);

    if (showWarning !== result) {
      this.setState({
        showWarning: result,
      });
    }
  }

  handleDefineSize(e, type) {
    const { value } = e.target;
    const { activeSize } = this.state;
    const initSize =
      activeSize.index === DEFINE_SIZE_INDEX
        ? { ...activeSize }
        : { index: DEFINE_SIZE_INDEX };
    this.setState({
      activeSize: {
        ...initSize,
        [type]: value,
      },
    });
  }

  getInputRef(type) {
    return type === 'width' ? this.inputWidthRef : this.inputHeightRef;
  }

  renderSizeInput(type) {
    const inputRef = this.getInputRef(type);
    return (
      <input
        className="light-box"
        type="number"
        ref={inputRef}
        onChange={e => this.handleInputChange(e, type)}
        onBlur={e => this.handleDefineSize(e, type)}
        placeholder={type === 'width' ? '宽' : '高'}
      />
    );
  }

  handleOK() {
    const { activeSize, showWarning } = this.state;
    const { index, width, height } = activeSize;
    if (showWarning) return;

    if (index === DEFINE_SIZE_INDEX && (!width || !height)) {
      this.setState({
        showWarning: true,
      });
      return;
    }
    gotoPosterEditor(width, height);
  }

  /**
   * 获取用户自定义常用尺寸
   */
  async getPosterCustomSizeList() {
    try {
      const res = await getPosterSizeList();
      if (res) {
        this.setState({
          customSizes: res.map((item, index) => ({
            index: SIZE_MAP.length + index,
            name: item.posterSizeName,
            width: item.posterW,
            height: item.posterH,
          })),
        });
      }
    } catch (e) {
      logger.error(e);
    }
  }

  // 设置海报尺寸模版
  getContent() {
    const { activeSize, showWarning, customSizes } = this.state;
    const { width, height } = activeSize;
    const sizeList = [...SIZE_MAP, ...customSizes];
    return (
      <div className="poster-setting-modal">
        <div className="type-setting">
          <PreviewSize width={+width} height={+height} />
        </div>
        <div className="size-setting">
          <p className="title">设置海报</p>
          <span className="text-item">推荐海报尺寸</span>
          <ul className="size-container">
            {sizeList.map(item => (
              <li
                className={`size-item ${item.index === activeSize.index &&
                  'active'}`}
                onClick={() => this.selectSize(item)}
                key={item.name}>
                {item.name} {item.width}px * {item.height}px
              </li>
            ))}
          </ul>
          <span className="text-item">自定义海报尺寸</span>
          <div className="user-defined">
            <div className="input-container">
              {this.renderSizeInput('width')}
              <span>x</span>
              {this.renderSizeInput('height')}
              <span className="light-box">px(像素)</span>
            </div>
            {showWarning && (
              <p className="warn-text">尺寸请输入40px~3000px的整数值</p>
            )}
          </div>
          <div className="btn-container">
            <span className="btn" onClick={() => this.props.hide(false)}>
              取消
            </span>
            <span className="btn" onClick={() => this.handleOK()}>
              确认
            </span>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const content = this.getContent();

    return (
      <Dialog
        style={{ width: 1044, height: 740 }}
        modal={true}
        content={content}
        closeBtn={true}
        onClose={() => {
          this.props.hide(false);
        }}
        parent={this}
      />
    );
  }
}

export default PosterSettingDialog;
